import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { NavItem, NavItemStatusID, NavItemTypeID } from './navigation-item';

declare function openNewBrowserUrl(url: string): boolean;
@Options({
  props: {
    navItems: {}
  },
  components: {}
})
export default class NavigationBar extends Vue {

  @Prop({default: false})
  public transparent!: boolean;

  @Prop()
  public navItems!: NavItem[];

  @Prop({default: false})
  public pageNav!: boolean;

  @Prop({ default: 'section'})
  public sectionTag!: string;

  public navigate(s: NavItem): void {
    if(s.type == NavItemTypeID.ExternalLink && s.status !== NavItemStatusID.Disabled) {
      if (typeof openNewBrowserUrl === 'function') {
        openNewBrowserUrl(s.externalLink);
      } else {
        window.open(s.externalLink, '_blank');
      }
    } else if (s.type == NavItemTypeID.InternalLink && s.status !== NavItemStatusID.Disabled &&
      !!s.routeSecName && (s.status === NavItemStatusID.Done || s.status === NavItemStatusID.NotCurrent)) {
      this.$router.push({ name: s.routeSecName, query: s.routeQuery });
    }
    this.$emit('clickedNavItem', s);
  }
}